import { WifiOff, Wifi, AlertTriangle } from 'lucide-react';

import { Badge } from '@/components/ui/badge';
import type { ConnectionStatus } from '@/types/api';

interface ConnectionStatusBadgeProps {
  status: ConnectionStatus;
}

export function ConnectionStatusBadge({ status }: ConnectionStatusBadgeProps): JSX.Element {
  switch (status) {
    case 'connected':
      return (
        <Badge variant="success" className="gap-1">
          <Wifi className="h-3 w-3" />
          Connected
        </Badge>
      );
    case 'disconnected':
      return (
        <Badge variant="secondary" className="gap-1">
          <WifiOff className="h-3 w-3" />
          Disconnected
        </Badge>
      );
    case 'error':
      return (
        <Badge variant="destructive" className="gap-1">
          <AlertTriangle className="h-3 w-3" />
          Connection Error
        </Badge>
      );
    default:
      return <Badge variant="outline">{status}</Badge>;
  }
}
